<template lang="pug">
    .user-nav
        el-dropdown(trigger='click', placement='bottom-end')
            span.el-dropdown-link(y-log-id="切换语言")
                | {{lang.text}}
                i.el-icon-arrow-down
            el-dropdown-menu(slot="dropdown" style='min-width: 122px;')
                el-dropdown-item(v-for="language in languages", :key="language.lang",
                @click.native='changeLang(language)', :y-log-id="language.text")
                    | {{language.text}}
        el-dropdown(trigger='click', placement='bottom-end', style="margin-left: 20px", v-if="showName")
            span.el-dropdown-link
                | Hello, {{fullname}}
                i.el-icon-arrow-down
            el-dropdown-menu(slot="dropdown" style='min-width: 122px;')
                el-dropdown-item(@click.native='logout()')
                    | {{$t('logout')}}
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import { languages } from "@/locale";
import ls from '@/utils/local-storage';

export default {
    data () {
        return {
            languages: languages
        };
    },
    props: {
        showName: {
            default: true
        }
    },
    computed: {
        ...mapGetters({
            'fullname': 'fullname'
        }),
        lang () {
            return _.find(languages, {lang: this.$i18n.locale}) || languages[0];
        }
    },
    mounted () {
    },
    methods: {
        logout: function (callback) {
            const url = window.location.href.replace(window.location.hash, '');
            const cb = callback ? decodeURIComponent(callback) : url;
            /* 登出passport.intra.yiducloud.cn*/
            // const myScript= document.createElement("script");
            // myScript.type = "text/javascript";
            // myScript.src="http://passport.intra.yiducloud.cn/sso/passport/user/logout?callback=#";
            // document.body.appendChild(myScript);

            /* 登出当前站点下的passport */
            /* 登出oauth */
            Promise.all([
                this.$http.get('/sso/oauth/logout?callback=' + decodeURIComponent(cb)),
                this.$http.get("/sso/passport/user/logout?callback=#")
            ]).then(() => {
                this.toLogin(callback);
            }, () => {
                this.toLogin(callback);
            });
        },
        toLogin () {
            this.$router.push({
                name: 'login'
            });
        },
        changeLang (language) {
            ls.set('lang', language.lang);
            window.location.reload();
            // loadLanguageAsync(language.lang);
        },
    }
};
</script>

<style lang="sass" scoped>
    .user-nav
        position: absolute
        right: 20px
        top: 20px
        z-index: 1000
    .el-dropdown-link
        font-family: PingFangSC-Regular
        font-size: 14px
        color: #333333
        text-align: right
        cursor: pointer
        i
            margin-left: 5px
</style>